module.exports = __webpack_public_path__ + "img/S.a4af0ebf.png";